import React, { Component } from 'react';
let indicators = {};

export default class ResourceIndicatorDataManager extends Component {
    state = {
        ttl: 0,
        progress: 0,
        increment: 0,
        status: null,
        indicators: {}
    }

    // Set the indicators, per resource, to an object of status 'null' and a code of 0 (zero).
    // This should allow local state to easily indicate that the status is in one of 4 possible states;
    //
    // 1. no state (null)
    // 2. pending state ('pending')
    // 3. success state ('success')
    // 4. failure state ('failure')
    //
    // This way, with the 'loading' and 'loadTime' propertoes the status can be translated to one of
    // the 4 listed states in order to make conditional data easily to use for the component that extends
    // this class as its parents.
    componentDidMount = () => {
        let indicators = {};
        const { resources } = this.props;
        for(let r in resources) indicators[r] = { status: null, code: 0 };
        this.setState({...this.state,
            indicators,
            ttl: Object.keys(indicators).length,
            increment: Math.round(100 / Object.keys(indicators).length)
        });
    }

    componentDidUpdate(prev) {
        this.updateState(prev);
    }

    updateState = prev => {
        const
        pResources = prev.resources,
        cResources = this.props.resources;

        let { allowFail } = this.props,
        newIndicators = {};

        allowFail = !!allowFail;
        for(let r in pResources) {
            const
            pLoading = pResources[r].loading,
            pLoadTime = pResources[r].loadTime,
            cLoading = cResources[r].loading,
            cLoadTime = cResources[r].loadTime;

            if((!pLoading && pLoadTime == null) && (cLoading && cLoadTime == null))
                newIndicators[r] = { status: 'pending', code: 0 };
            else if((pLoading && pLoadTime == null) && (!cLoading && cLoadTime != null))
                newIndicators[r] = { status: 'success', code: 0 };
            else if((pLoading && pLoadTime == null) && (!cLoading && cLoadTime == null))
                newIndicators[r] = { status: 'failure', code: 0 };
        }

        if(Object.keys(newIndicators).length > 0) {
            let status = null,
            progress = this.state.progress,
            indicators = {...this.state.indicators};

            for(let i in indicators)
                if(newIndicators.hasOwnProperty(i))
                    indicators[i] = newIndicators[i];

            // Set the overall status to 'pending' if any of the status's are 'pending';
            for(let i in indicators)
                if(indicators[i].status === 'pending') {
                    status = 'pending';
                    break;
                }

            // Set the overall status based on all 'success' or all 'failure'. Otherwise,
            // if the 'allowFail' flag is set to 'true', set the status to 'success'
            // as long as, at least, ONE of the status's is successful. Otherwise, use
            // the 'failure' status if 'allowFail' is either 'false' or not present and,
            // at least, ONE of the status's is 'failure'.
            if(status == null) {
                let set = new Set();

                for(let i in indicators) {
                    set.add(indicators[i].status);
                    if(indicators[i].status === 'success')
                        progress += this.state.increment;
                }

                if(set.has('success') && !set.has('failure')) status = 'success';
                else if(!set.has('success') && set.has('failure')) status = 'failure';
                else if(set.has('success') && set.has('failure'))
                    if(allowFail) status = 'success';
                    else status = 'failure';
            }

            if(status === 'success') progress = 100;
            this.setState({...this.state, progress, status, indicators });
        }
    }
}
